<template>
  <div
    class="mx-auto window win-card draggable resizable"
    style="max-width: 900px; width: 100%; margin: 32px auto 0;"
    v-if="open"
    @click="$emit('toFront')"
  >
    <WindowBar
      title="Projects"
      @close="$emit('close')"
      @maximize="maximized=true"
      @minimize="maximized=false"
    />
    <div v-show="maximized">
      <div class="filter-row">
        <button
          v-for="(icon, index) in buttonIcons"
          :key="icon"
          class="filter-btn"
          :class="{ 'filter-active': toggle_exclusive.includes(index) }"
          @click="toggleFilter(index)"
        >
          <span :class="'mdi ' + icon"></span>
        </button>
      </div>
      <div class="projects-grid">
        <div
          class="project-col"
          v-for="card in filteredProjects"
          :key="card.id"
        >
          <ProjectCard v-bind:card="card" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectCard from './ProjectCard.vue'
import WindowBar from './WindowBar.vue'

export default {
  name: "ProjectsNE",
  data: () => ({
    buttonIcons: ['mdi-language-python', 'mdi-language-java', 'mdi-language-c'],
    cards: [
      {
        title: "Oliver's Room", subtitle: 'an arcade style platformer implemented using PyGame',
        src: require('@/assets/oliversrooms.png'),
        flex: 6,
        details: "WORK IN PROGRESS: Oliver's Room is an arcade style platformer game including multiple levels, enemies, and consumables. The game was implemented in Python using the PyGame module",
        tag: 0,
        actions: [
          { title: 'GitHub', link: 'https://github.com/oliverclark15/arcade-game' },
        ],
        id: 0,
      },
      {
        title: 'Capstone Research Paper', subtitle: 'Authored "Can Duplicate Posts on Stack Overflow Benefit the Software Development Community?" an original research paper alongside fellow McGill undergraduates, graduatates, and a professor.',
        src: require('@/assets/msr1.png'),
        flex: 6,
        details: 'Authored an original paper on duplicate questions on popular developer Q&A site Stack Overflow. The paper was selected for publication at the IEEE/ACM International Conference on Mining Software Repositories. Finally, the paper won the Best Student Presentation award at the conference. ',
        tag: 0,
        actions: [
          { title: 'PDF', link: 'http://rebels.ece.mcgill.ca/papers/msr2019_abric.pdf' },
          { title: 'IEEE', link: '' },
        ],
        id: 1,
      },
      {
        title: 'Tablut Agent',
        subtitle: 'A Tablut (Viking Chess) game playing agent written in Java',
        src: require('@/assets/Tablut_board.svg.png'),
        flex: 6,
        details: 'Tablut agent implented using an Minimax search algorithm with alpha-beta pruning in Java. The agent performed in the top 20% of agents competing against 150+ classmates.',
        tag: 1,
        actions: [
          { title: 'PDF', link: '/tablut_report.pdf' },
        ],
        id: 2,
      },
      {
        title: 'Distributed RMS',
        subtitle: 'A distributed reservation system implemented in Java',
        src: require('@/assets/distributed.png'),
        flex: 6,
        details: 'A distributed reservation system to allow a user to reserve flights, cars, rooms, or some combination of the three. The system was implemented in Java over TCP, using strict 2-phase locking,  2-phase commits, and shadowing protocols.',
        tag: 1,
        actions: [
          { title: 'GitHub', link: 'https://github.com/metchel/Comp100000000Project' },
          { title: 'PDF', link: '/512_report.pdf' }
        ],
        id: 3,
      },
      {
        title: 'Rendering System',
        subtitle: 'A rendering system built on top of TinyRender implemented in C++.',
        src: require('@/assets/cubebox.png'),
        flex: 6,
        details: 'Implemented several different path tracers, lighting models, GLSL shaders to produce brilliant outputs',
        tag: 2,
        actions: [],
        id: 5,
      },
    ],
    toggle_exclusive: [0, 1, 2],
    open: true,
    maximized: true,
  }),
  components: {
    ProjectCard,
    WindowBar
  },
  computed: {
    filteredProjects() {
      return this.cards.filter(x => this.toggle_exclusive.includes(x.tag));
    }
  },
  methods: {
    toggleFilter(index) {
      const pos = this.toggle_exclusive.indexOf(index);
      if (pos === -1) {
        this.toggle_exclusive.push(index);
      } else {
        this.toggle_exclusive.splice(pos, 1);
      }
    }
  }
};
</script>

<style src="98.css"></style>
<style scoped>
.filter-row {
  display: flex;
  justify-content: center;
  gap: 8px;
  padding: 12px;
}

.filter-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  background: #c0c0c0;
  border: 2px solid;
  border-color: #ffffff #808080 #808080 #ffffff;
}

.filter-btn:active,
.filter-btn.filter-active {
  border-color: #808080 #ffffff #ffffff #808080;
  background: #a0a0a0;
}

.projects-grid {
  display: flex;
  flex-wrap: wrap;
  padding: 8px;
  gap: 16px;
}

.project-col {
  flex: 1 1 calc(50% - 16px);
  min-width: 280px;
}
</style>
